import type {Sector} from "crqlar-react-common/dist/models/sector/sector.model";
import {useAuthorizedViaAdmin} from "crqlar-react-common/dist/utils/hooks/admin/useAuthorizedViaAdmin";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";
import type {ReactElement} from "react";
import {PageShell, type TabRoute} from "../layout/PageShell";
import SpaDailyList from "../dailyLists/SpaDailyList";
import SpaInsightsTab from "../insights/SpaInsightsTab";
import {ReservationCalendar} from "./ReservationCalendar";
import SpaReservationList from "./lists/SpaReservationList";

interface Props {
    appName: string;
    icon: ReactElement;
    tabPath: (tab: string) => string;
    sector: Sector;
}

export default function Spa({appName, icon, tabPath, sector}: Props) {
    const {t} = useLocalize();
    const isAuthorizedViaAdmin = useAuthorizedViaAdmin();

    const tabs: TabRoute[] = [
        {
            path: tabPath("daily"),
            label: t("Daily List"),
            render: () => sector.id ? <SpaDailyList sectorId={sector.id}/> : null,
        },
        {
            path: tabPath("calendar"),
            label: t("Calendar"),
            render: () => sector.id ? <ReservationCalendar sector={sector}/> : null,
        },
        {
            path: tabPath("list"),
            label: t("List"),
            render: () => sector.id ? <SpaReservationList sectorId={sector.id}/> : null,
        },
        // ...(isAuthorizedViaAdmin
        //     ? [{
        //         path: tabPath("insights"),
        //         label: t("Insights"),
        //         render: () => <SpaInsightsTab sector={sector}/>,
        //     }]
        //     : []),
    ];

    return (
        <PageShell
            icon={icon}
            title={appName}
            documentTitle={appName}
            tabs={tabs}
        />
    );
}
